import React, { Component } from 'react';
import { MDBTable, MDBTableBody} from 'mdbreact';
import { Badge, InputGroup, Form,FormControl, Button, OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';

import $ from 'jquery';
export default class FileList extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            currentKeyword:"", fileTypeFilter: this.props.fileFilter, data: [], originalData: [], isDataLoading: false,
            documentIdsInList: props.documentIdsInList, message: "", nextPageToken:"", urlName: "", URL: "",urlTargetBlank:false, error:false
        };
        this.addDocs = this.addDocs.bind(this);
        this.addURL = this.addURL.bind(this);
        
        this.onChangeUrlName = this.onChangeUrlName.bind(this);
        this.onChangeURL = this.onChangeURL.bind(this);    
        this.onUrlChkChange = this.onUrlChkChange.bind(this);
        this.refresh = this.refresh.bind(this);
        this.showMore = this.showMore.bind(this);    
    }


    componentWillReceiveProps(nextProps) {        
        var prevData = this.state.data;
        this.setState({ documentIdsInList: nextProps.documentIdsInList, data: prevData.filter(x => !nextProps.documentIdsInList.includes(x.id)) });
        //this.filterListData("");
        if (this.props.fileFilter !== nextProps.fileFilter) {
        
            var filter = nextProps.fileFilter.toLowerCase();         
            this.setState({ data: this.state.originalData.filter(x => x.mimeType.includes(filter) && !this.state.documentIdsInList.includes(x.id)) }, () => {
                this.setState({ fileTypeFilter: filter }, () => { this.filterListData(this.state.currentKeyword); } )
            });        
        }      
    }
    getData = async (nextPageToken) => {        
      
        this.setState({ isDataLoading: !!!nextPageToken });
        const resp = await fetch('api/doc/doclist', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(nextPageToken),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (resp.status === 200) {
            try {
                const jdata = await resp.json();
               
                if (this._isMounted) {
                    //if (this.jdata == null) {
                    //    console.log(jdata);
                    //    this.setState({ message: 'Google docs not found or are not accessible.' });
                    //}
                    //else {
                      
                    //}
                    var newOriginalData = this.state.originalData;
                    var newData = this.state.data;

                    if (this.state.originalData.length === 0) {
                        newOriginalData = jdata.docs;
                        newData = jdata.docs.filter(x => x.mimeType.includes(this.state.fileTypeFilter) && !this.state.documentIdsInList.includes(x.id));
                    } else {
                        newOriginalData = newOriginalData.concat(jdata.docs);
                        newData = newData.concat(jdata.docs.filter(x => x.mimeType.includes(this.state.fileTypeFilter) && !this.state.documentIdsInList.includes(x.id)));
                    }

                    await this.setState({
                        data: newData, nextPageToken: jdata.nextPageToken, originalData: newOriginalData, isDataLoading: false
                    })

                    //await this.setState({
                    //    data: jdata.docs.filter(x => x.mimeType.includes(this.state.fileTypeFilter) && !this.state.documentIdsInList.includes(x.id)),
                    //    originalData: jdata.docs, isDataLoading: false
                    //})

                    this.filterListData(this.state.currentKeyword);
                }

            } catch (e) {             
               await  this.setState({ error: true, isDataLoading: false })
            }
        }
        else if (resp.status === 401) {
            this.setState({ message: '401: Not Authorized', isDataLoading: false })
        }
        else {
            this.setState({ message: 'There was a problem, please try again later.' });
        }
       
    }
   
    filterListData = async (keyword) => {            
     
        await this.setState({currentKeyword:keyword, message: "" });
        const searchInput = document.getElementById("keywords-input");
        let keywordTrLC = keyword.trim().toLowerCase();
        if (keywordTrLC.includes("docs.google.com/document/d/") || keywordTrLC.includes("docs.google.com/spreadsheets/d/") || keywordTrLC.includes("docs.google.com/presentation/d/")){
            var keysplit = keyword.split("/");
            var docid = keysplit[5];
            if (docid !== "" && docid.length > 1) {
                const resp = await fetch('api/doc/getfromlink?id='+docid, {
                    method: 'GET',
                    credentials: 'same-origin'
                });
                if (resp.status === 200) {
                    try {
                        const jdatadoc = await resp.json();

                        if (this._isMounted) {

                            if (this.state.documentIdsInList.includes(jdatadoc.id)) {
                                this.setState({ message: 'Google doc found but is already in this collection.' })
                            }
                            else if (this.state.originalData.filter(file => file.id === jdatadoc.id).length === 0) {
                                let oDataMut = this.state.originalData;
                                oDataMut.push(jdatadoc);
                                await this.setState({ originalData: oDataMut });
                            }

                            searchInput.value = jdatadoc.name;
                            keyword = jdatadoc.name;
                        }

                    } catch (e) {

                        this.setState({ message: 'Google doc not found or is not accessible.' });
                    }
                }
                else if (resp.status === 401) {
                    this.setState({ message: '401: Not Authorized'})
                }
                else {

                    this.setState({ message: 'There was a problem, please try again later' });
                }
            }
            }         
              
        keyword = keyword ? keyword.trim().toUpperCase() : "";
        if (searchInput) {
            searchInput.value = keyword === "" ? keyword : searchInput.value;
        }
        
      
        const documentIdsInList = this.state.documentIdsInList;
    
        let filteredData = this.state.originalData.filter(file => file.mimeType.includes(this.state.fileTypeFilter) && !documentIdsInList.includes(file.id));
       
        if (keyword.length) {
            filteredData = filteredData.filter(file =>
                ((file.name && file.name.trim().toUpperCase().includes(keyword)) ||
                    (file.description && file.description.trim().toUpperCase().includes(keyword)) ||
                    (file.description && file.name &&
                        ((file.description.trim() + "/").toUpperCase().includes(keyword) ||
                            (file.description.trim() + "/" + file.name.trim()).toUpperCase().includes(keyword))
                    ) 
                )
            );
        }
        //        if (filteredData.length === 0 && this.state.message === "") {
        if (filteredData.length === 0 ) {
            if (!!!this.state.nextPageToken) {
                var msg = "No documents found...";
                if (this.state.error) {
                    msg += "There may have been an issue accessing your google documents.";
                }
                this.setState({ message: msg});
            }
            else {
                this.setState({ message: "No results found.  Some items are not shown.  To search against more items, click 'show more', or paste a direct URL to the item you wish to add in the search box." });
            }
        }
        this.setState({ data: filteredData });
    }

     onChangeUrlName(e){
         this.setState({ urlName: e.target.value})
    }
    onChangeURL(e) {
        this.setState({ URL: e.target.value })
    }
    onUrlChkChange(e) {
        this.setState({ urlTargetBlank: e.target.checked });
    }
    onDocumentSelection = ({ id, isChecked }) => {
        console.log(id);
        let data = this.state.data;
        let originalData = this.state.originalData;

        let doc = data.filter(file => file.id === id);
        if (doc && doc.length) {        
            doc[0].isChecked = isChecked;
        }
        doc = originalData.filter(file => file.id === id);
        if (doc && doc.length) {       
            console.log(doc);
            doc[0].isChecked = isChecked;
        }
        this.setState({ data: data, originalData: originalData });
    }
    addDocs = (e) => {
        e.preventDefault();
        //do stuff to add the files and clear check list
        var data = [];
        var coll = $(".form-check-input:checked", $("#fileModal"));
        console.log(coll.length);

        coll.each(function () {
            if ($(this).is(':checked')) {
                //var p = $(this).parent(".col");

                var fid = $(this).data('id');// $(".form-check-id", p).val();
                var fname = $(this).data('name');// $(".form-check-label", p).text();
                var fdrive = $(this).data('drive');
                var ftype = $(this).data('type');
                //Declare expected form values
                var dataItem = { "text": fname, "icon": "", "href": fid, "target": ftype, "title": fdrive };                     
                data.push(dataItem);
            }
        });
        this.props.editorAdd(data);
        $('#fileModal').modal('hide');
    }
    addURL = (e) => {
        e.preventDefault();
        console.log(e);
        var dataArr = [];     
        var fname = this.state.urlName;         
        //Declare expected form values
        var dataItem = { "text": fname, "icon": this.state.urlTargetBlank , "href": this.state.URL, "target": "URL", "title": "" };
       
        dataArr.push(dataItem);
        this.props.editorAdd(dataArr);
        $('#fileModal').modal('hide');
        this.setState({ urlName: "", URL: "", urlTargetBlank:false });
    }
    componentDidMount() {
        this._isMounted = true;
        (  async () => {
            this.getData();
        })();
       
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    async refresh() {
        if (!this.state.isDataLoading) {

            await this.setState({ data: [], originalData: [], nextPageToken: "" });            
            this.getData();
        }
    }
    showMore() {
        (async () => {
            this.getData(this.state.nextPageToken);
        })();
        
    }
    render() {
        const msg = this.state.message;
        const isLoading = this.state.isDataLoading;
        const loader = <div className="fa-3x">
            <h6 className='text-center' ><i className="fas fa-spinner fa-pulse"></i>  Please wait files are loading</h6>
        </div>

        const listcontent = this.state.data.length > 0 ? (this.state.data.map(file => <DriveFile key={file.id} onDocumentSelection={this.onDocumentSelection} {...file} handleDoc={this.props.handleDoc} isModal={this.props.isModal} />)) : <h6 className='text-center' > {msg}</h6>;
        const modalListContent = isLoading ? loader :
            (<MDBTable responsive striped id="doc-table" style={{ transition: "visibility 0s, opacity 0.5s linear" }} >

                <MDBTableBody className="modal-doc-list">
                    {listcontent}
                </MDBTableBody>
            </MDBTable>);
        const showMoreButton = !!this.state.nextPageToken ? <button type="button" className="btn btn-sm btn-info" onClick={this.showMore} > Show More</button> : "";

        const listparent = !this.props.isUrl ?
            <div className="modal" tabIndex="-1" role="dialog" id="fileModal">
                <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Select Items To Add</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-header doc-search-header" >
                            <div className="w-100">
                                <Row>
                                    <Col>
                                        <InputGroup>
                                            <FormControl
                                                id="keywords-input"
                                                onChange={e => this.filterListData(e.target.value)}
                                                type="text"
                                                placeholder="Search by keywords or full google URL"
                                                aria-label="Search by keywords or full google URL"
                                            />
                                            <InputGroup.Append>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip >
                                                            Refresh file list.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <Button variant="secondary" onClick={this.refresh}><i className="fas fa-sync"></i></Button>
                                                </OverlayTrigger>
                                            </InputGroup.Append>
                                        </InputGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <small className="text-muted">&nbsp;Showing <span id="filteredDocsCount">{isLoading ? 0 : this.state.data.length.toString()}</span> / {isLoading ? 0 : this.state.originalData.length.toString()} files. </small>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col></Col>
                                </Row>

                            </div>
                        </div>
                        <div className="modal-body">
                            <form>
                                {modalListContent}

                            </form>
                            <div className="text-center">  {showMoreButton} </div>
                          
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={this.addDocs} ><i className="fas fa-plus"></i> Add</button>
                            <button type="button" className="btn btn-secondary" data-dismiss="modal"> Cancel</button>
                          
                        </div>
                    </div>
                </div>
            </div> :
            <div className="modal" tabIndex="-1" role="dialog" id="fileModal">
                <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"><i className="fas fa-link"></i>Add embedded website from URL</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-header doc-search-header" >
                            <div className="w-100">
                              

                            </div>
                        </div>
                        <div className="modal-body">
                            <form class="form-horizontal m15" onSubmit={this.addURL}>
                                <div class="form-group row">
                                    <label htmlFor="urlName" className="col-sm-2">Name</label>
                                    <div class="col-sm-8">
                                        <Form.Control type="text" className="form-control" name="urlName" id="urlName"
                                            value={this.state.urlName} onChange={this.onChangeUrlName} required/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label htmlFor="URL" className="col-sm-2">URL</label>
                                    <div class="col-sm-8">
                                        <Form.Control type="url" className="form-control" name="URL" id="URL" placeholder="https://domain.com"
                                            value={this.state.URL} onChange={this.onChangeURL} required pattern="https://.+"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label htmlFor="urlChk" className="col-sm-2"></label>
                                    <div class="col-sm-8">
                                        <Form.Check type="checkbox" label="Open in new tab" id="urlChk" onChange={this.onUrlChkChange } / >
                                       
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button  className="btn btn-primary" type="submit" ><i className="fas fa-plus"></i> Add</button>
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal"><i className="fas fa-times"></i> Close</button>
                                </div>
                            </form>

                        </div>
                        
                    </div>
                </div>
            </div>;

        return (
            <div> {listparent}</div>
        );

    }
}


class DriveFile extends Component {


    onDocumentSelection = (e) => {
        const id = e.target.id;     
        const isChecked = e.target.checked;
        this.props.onDocumentSelection({ id, isChecked });
    }
    formateDate(ISODateString) {
        var date = new Date(ISODateString);
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
        var year = date.getFullYear();
        return year + "-" + month + "-" + day;
    }
    render() {
        const fileIconArray = {
            "document": ["file-word", "primary"],
            "presentation": ["file-powerpoint", "warning"],
            "spreadsheet": ["file-excel", "success"]
        }      
        
        let mimetype = this.props.mimeType.split('.')[2];        
   
        const shared = !!this.props.sharedWithMeTime ? <Badge pill variant="success" style={{ opacity: "0.5" }}><i className="fas fa-share-alt"></i> Shared With Me</Badge> :
            (!!this.props.shared ? <Badge pill variant="info" style={{ opacity: "0.5" }}><i className="fas fa-share-alt"></i> Shared</Badge> : "");
        const fileIcon = <span  className={"text-"+ fileIconArray[mimetype][1]}><i className={"fas fa-"+fileIconArray[mimetype][0]}></i></span>
       
     
        return  (
            <tr id={"tr_" + this.props.id}>
                <td style={{ width: "50px" }}>
                    <div >{/* //className="form-check" */}
                        &nbsp;&nbsp;&nbsp;
                        <input className="form-check-input ml-0" type="checkbox" data-id={this.props.id} data-name={this.props.name} data-drive={this.props.driveId} data-type={this.props.mimeType} id={this.props.id} value=""  ></input>
                        <input type="hidden" className="form-check-id" value={this.props.id}></input>
                        &nbsp;&nbsp;&nbsp;
                    </div>
                </td>
                <td style={{ width: "95%" }} >
                    <label htmlFor={this.props.id} className="m-0">
                        {fileIcon} {this.props.name} {shared}
                    </label>

                </td>
                <td className="min-width-100" style={{ width: "100px" }}> {this.formateDate(this.props.modifiedTime)} </td>
            </tr>
       
        )
            

    }
}